(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/table/assets/javascripts/components/table.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/table/assets/javascripts/components/table.trinidad.js');
"use strict";

(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (table)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const _excluded = ["className", "children", "bordered", "colBordered", "large", "striped", "inverted"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  ;
  function Table(_ref) {
    let className = _ref.className,
      children = _ref.children,
      bordered = _ref.bordered,
      colBordered = _ref.colBordered,
      large = _ref.large,
      striped = _ref.striped,
      inverted = _ref.inverted,
      props = _objectWithoutProperties(_ref, _excluded);
    const classes = ['table', 'f-numeric'];
    if (className) {
      classes.push(className);
    }
    if (inverted) {
      classes.push('table-inverted');
    } else {
      classes.push('table-default');
    }
    if (bordered) {
      classes.push('table-bordered');
    }
    if (colBordered) {
      classes.push('table-col-bordered');
    }
    if (large) {
      classes.push('table-large');
    }
    if (striped) {
      classes.push('table-striped');
    }
    return React.createElement("table", _extends({
      className: classes.join(' ')
    }, props), children);
  }
  Table.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "Table",
    "props": {
      "bordered": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "colBordered": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "inverted": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "large": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "striped": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      }
    }
  };
  const table = Table;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactTable = window.svs.ui.ReactTable || {}).Table = __webpack_exports__["default"];
})();

 })(window);